import { TOK_REFERRAL_OPTIONS } from "@/lib/tracking";

/**
 * "Where did you hear about TOK?" — premium chip-based picker.
 * Mobile-friendly tap targets, animated, branded.
 */
export default function ReferralSourceSelector({
  value = "",
  onChange,
  required = true,
  label = "Where did you hear about Temple of Kulture?",
  testIdPrefix = "referral",
}) {
  const slug = (s) =>
    s
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

  return (
    <div data-testid={`${testIdPrefix}-picker`}>
      <p className="text-[10px] uppercase tracking-[0.32em] font-bold text-zinc-400 mb-3">
        {label} {required && <span className="text-amber-400">*</span>}
      </p>
      <div className="flex flex-wrap gap-2">
        {TOK_REFERRAL_OPTIONS.map((opt) => {
          const on = value === opt;
          return (
            <button
              type="button"
              key={opt}
              onClick={() => onChange(opt)}
              data-testid={`${testIdPrefix}-${slug(opt)}`}
              aria-pressed={on}
              className={`px-3.5 py-2.5 text-[11px] uppercase tracking-[0.18em] font-bold border transition-all duration-200 active:scale-95 ${
                on
                  ? "bg-amber-400 text-black border-amber-400 shadow-[0_0_24px_-8px_rgba(251,191,36,0.6)]"
                  : "border-white/10 hover:border-amber-400 hover:bg-amber-400/5 hover:text-amber-400 text-zinc-300"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}
